/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_TitleInputs */



/**
* | output |
* | --- |
* | "Speaker Manager" |
*
* @param {Speaker_Manager_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_title = /** @type {((inputs?: Speaker_Manager_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gestionnaire des locuteurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprechermanager")
	if (locale === "it") return /** @type {LocalizedString} */ ("Responsabile degli altoparlanti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Менеджер спикеров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gerente de oradores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("演讲者经理")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーマネージャー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ता प्रबंधक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerente de palestrantes")
	return /** @type {LocalizedString} */ ("Speaker Manager")
});